// Links that leave tykkit.com shouldn't pass ranking signals to the other
// site, so every external <a> carries nofollow next to the usual opener
// protection.
export const EXTERNAL_REL = "nofollow noopener noreferrer";

const SITE_HOST = /(^|\.)tykkit\.com$/i;

// Only absolute (or protocol-relative) URLs can point off-site; relative
// paths, #anchors, mailto: and tel: all stay internal.
export function isExternalHref(href) {
  if (typeof href !== "string") return false;
  const value = href.trim();
  if (!/^(?:https?:)?\/\//i.test(value)) return false;
  try {
    return !SITE_HOST.test(new URL(value, "https://tykkit.com").hostname);
  } catch {
    return false;
  }
}

export const externalRel = (href) =>
  isExternalHref(href) ? EXTERNAL_REL : undefined;
